import moment from "moment";
import Vue from "vue";
import MasterService from "@/services/MasterService";
import UserService from "@/services/UserService";
import DistributorService from "@/services/DistributorService";
import {
  addAllKeyWordsIntoArrays,
  addAllKeyWordsIntoArrays_2
} from "@/helper/collection";

import { router } from "@/router";

const state = {
  CinemasList: [],
  DistributorsList: [],
  DistributorsMasterMovieList: [],
  PosUsersList: [],
  AggregatorUserList: [],
  PaymentTypesList: [],
  OfferVoucherTypesList: [],
  OrgImage: null,
  noOfScreens: 1,
  currentCinemaIndex: 0,
  BacktoSeatLayout: false,
  DaysList: [],
  RawMaterialCategoryList: [],
  isCinemaManager: false,
  dropdownSelectedCinema: undefined,
  global_options_latest: [],
  organizationDetails: {},
  hotPickModules: [],
  isGogoCinema: "",
  health_meta: {
    git: {},
    os: {},
    process: {}
  },
  mobileSidebar: false,
  isMobile: false,
  isReprint: false,
  selectSeatCountPopUp: 10,
  TimeFormat: "HH:mm",
  TEST_SETUP: false,
  show_send_sms_section: "Y",
  direct_print: "N",
  pos_amount_calculation_check: "Y",
  pos_final_page_standby_time: "3",
  contentLangArray: [],
  selected_content_language: null,
  area_lang_id: null,
  cinema_settings: [],
  cine_seat_release_time: 0,
  pos_seat_release_alert_time_in_sec: 60,
  seat_extend_timer: 0,
  client_setup_name: "",
  pos_lock_screen_time: 10000,
  default_selected_food_category: null,
  showPrintReceiptBtn: "Y",
  MANAGER_AUTH_FOR_CHANGES: 'N',
  MANAGER_AUTH_FOR_REPRINT: 'N',
  SHOW_VEG_NONVEG_lOGO: 'Y',
  AUTO_ADMIT_TICKET_AFTER_SHOW: 'N',
  OPEN_OFFER_POPUP: 'N',
  USE_TIM_INTEGRATION: 'N',
  USE_NEOLEAP_POS_PAYMENT: 'N',
  PRINT_TIM_CARD_RECEIPT_POS: 'Y',
  HARDWARE_LOCATIONS: [],
  hardwareLocationId: null,
  DELIVER_ITEM_FROM_POS_PICKUP: 'Y',
  DIRECT_DELIVER_READY_TO_SERVE_ITEMS: 'N',
  PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY: 'Y',
  HARDWARE_SETTING_ON_POS: 'N',
  ALLOW_CINEMA_SPECIFIC_REFUND_ONLY: 'N',
  ALLOW_CINEMA_SPECIFIC_SWAP_ONLY: 'N',
  NEOLEAP_WEBSOCKET_URL: 'wss://localhost:7000/neoleap_integration',
  ALL_CINEMA_AARAY: [],
  HardwareSettings: {
    selectedLocation: "",
    hardware_location_id: null,
    cinema_id: null,
    selectedCinema: ""
  }
};

const mutations = {
  SET_POS_FINAL_PAGE_STANDBY_TIME_IN_MINS: (state, payload) => {
    if (!isNaN(payload) && payload > 0) {
      state.pos_final_page_standby_time = parseInt(payload);
    } else {
      state.pos_final_page_standby_time = 3;
    }
  },
  SET_DROPDOWN_AREA_LANGUAGE: (state, payload) => {
    state.selected_content_language = payload;
    state.area_lang_id = payload.lang_id;
    window.localStorage.setItem("area_lang", JSON.stringify(payload));
  },
  SET_CLIENT_SETUP_NAME: (state, payload) => {
    state.client_setup_name = payload;
  },
  SET_DELIVER_ITEM_FROM_POS_PICKUP: (state, payload) => {
    state.DELIVER_ITEM_FROM_POS_PICKUP = payload;
  },
  SET_ALLOW_CINEMA_SPECIFIC_REFUND_ONLY: (state, payload) => {
    state.ALLOW_CINEMA_SPECIFIC_REFUND_ONLY = payload;
  },
  SET_ALLOW_CINEMA_SPECIFIC_SWAP_ONLY: (state, payload) => {
    state.ALLOW_CINEMA_SPECIFIC_SWAP_ONLY = payload;
  },
  SET_PRINT_TIM_RECEIPT_FROM_POS: (state, payload) => {
    state.PRINT_TIM_CARD_RECEIPT_POS = payload;
  },
  SET_HARDWARE_LOCATION_LIST: (state, payload) => {
    state.HARDWARE_LOCATIONS = payload;
  },
  SET_HARDWARE_LOCATION_ID: (state, payload) => {
    state.hardwareLocationId = payload;
  },
  SET_HARDWARE_SETTING_ON_POS: (state, payload) => {
    state.HARDWARE_SETTING_ON_POS = payload;
  },
  SET_HARDWARE_SETTINGS_OBJ: (state, payload) => {
    Object.keys(state.HardwareSettings).map((key) => {
      state.HardwareSettings[key] = payload[key]
    })
  },
  SET_OFFER_POPUP_OPEN_AUTOMATICALLY: (state, payload) => {
    state.OPEN_OFFER_POPUP = payload;
  },
  SET_SHOW_VEG_NONVEG_lOGO: (state, payload) => {
    state.SHOW_VEG_NONVEG_lOGO = payload;
  },
  SET_TIM_INTEGRATION: (state, payload) => {
    if(payload == 'Y') {
      state.USE_TIM_INTEGRATION = payload;
      state.USE_NEOLEAP_POS_PAYMENT = 'N';
    } else {
      state.USE_TIM_INTEGRATION = payload;
    }
  },
  SET_DIRECT_DELIVER_READY_TO_SERVE_ITEMS: (state, payload) => {
    state.DIRECT_DELIVER_READY_TO_SERVE_ITEMS = payload;
  },
  SET_PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY: (state, payload) => {
    state.PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY = payload;
  },
  SET_NEOLEAP_INTEGRATION: (state, payload) => {
    if(payload == 'Y') {
      state.USE_NEOLEAP_POS_PAYMENT = payload;
      state.USE_TIM_INTEGRATION = 'N';
    } else {
      state.USE_NEOLEAP_POS_PAYMENT = payload;
    }
  },
  SET_NEOLEAP_WEBSOCKET_URL: (state, payload) => {
    state.NEOLEAP_WEBSOCKET_URL = payload;
  },
  SET_AUTH_REQURIED_FOR_CHANGES: (state, payload) => {
    state.MANAGER_AUTH_FOR_CHANGES = payload;
  },
  SET_AUTH_REQURIED_FOR_REPRINT: (state, payload) => {
    state.MANAGER_AUTH_FOR_REPRINT = payload;
  },
  SET_CONTENT_LANGUAGES: (state, payload) => {
    state.contentLangArray = payload;
  },
  SET_AUTO_ADMIT_TICKET: (state, payload) => {
    state.AUTO_ADMIT_TICKET_AFTER_SHOW = payload;
  },
  POS_LOCK_SCREEN_TIME: (state, payload) => {
    if (!isNaN(payload)) {
      state.pos_lock_screen_time = parseInt(payload);
    } else {
      state.pos_lock_screen_time = 10000;
    }
  },
  POS_SEAT_EXTEND_ALERT_IN_SEC: (state, payload) => {
    if (!isNaN(payload) && payload > 60) {
      state.pos_seat_release_alert_time_in_sec = parseInt(payload);
    } else {
      state.pos_seat_release_alert_time_in_sec = 60;
    }
  },
  SET_CINEMA_SEAT_SETTINGS: (state, payload) => {
    state.cinema_settings = payload;
    state.cine_seat_release_time = payload[0].cine_seat_release_time_in_mins;
    let posSeatPopinMins =
      parseInt(state.pos_seat_release_alert_time_in_sec) / 60;
    if (
      !isNaN(payload[0].cine_seat_release_time_in_mins) &&
      payload[0].cine_seat_release_time_in_mins > posSeatPopinMins
    ) {
      state.seat_extend_timer =
        (parseFloat(payload[0].cine_seat_release_time_in_mins) -
          parseFloat(posSeatPopinMins)) *
        60000;
    } else {
      state.seat_extend_timer = 0;
    }
  },
  SET_POS_AMOUNT_VALIDATION: (state, payload) => {
    state.pos_amount_calculation_check = payload;
  },
  SET_REPRINT: (state, payload) => {
    state.isReprint = payload;
  },
  SET_DIRECT_PRINT: (state, payload) => {
    state.direct_print = payload;
  },
  SET_PRINT_RECEIPT_BTN_POS: (state, payload) => {
    state.showPrintReceiptBtn = payload;
  },
  SET_SHOW_SMS_SECTION: (state, payload) => {
    state.show_send_sms_section = payload;
  },
  SET_GOGO_CINEMA: (state, payload) => {
    state.isGogoCinema = payload;
  },
  SET_DEFAULT_SELECTED_FOOD_CATEGORY: (state, payload) => {
    state.default_selected_food_category = payload;
  },
  SET_ORG_DETAILS: (state, payload) => {
    state.organizationDetails = payload;
  },
  SET_HOT_PICKS_MODULES: (state, payload) => {
    state.hotPickModules = payload;
  },
  SET_GLOBAL_OPTIONS: (state, payload) => {
    state.global_options_latest = payload;
  },
  SET_HEALTH_META: (state, payload) => {
    state.health_meta = payload;
  },
  SET_POS_USERS_LIST: (state, payload) => {
    state.PosUsersList = addAllKeyWordsIntoArrays(payload);
  },
  SET_AGGREGATOR_USERS_LIST: (state, payload) => {
    state.AggregatorUserList = addAllKeyWordsIntoArrays(payload);
  },
  SET_PAYMENT_TYPES_LIST: (state, payload) => {
    state.PaymentTypesList = payload;
    // addAllKeyWordsIntoArrays(
    //   payload,
    //   "pm_payment_mode"
    // );
  },
  SET_OFFERS_VOUCHER_TYPES_LIST: (state, payload) => {
    state.OfferVoucherTypesList = payload;
  },
  SET_CINEMAS_LIST: (state, payload) => {
    state.CinemasList = payload;
  },
  SET_RAW_MATERIAL_CATEGORY_LIST: (state, payload) => {
    state.RawMaterialCategoryList = addAllKeyWordsIntoArrays(
      payload,
      "rmc_category"
    );
  },
  SET_DISTRIBUTORS_LIST: (state, payload) => {
    state.DistributorsList = payload;
  },
  SET_DISTRIBUTORS_MASTER_MOVIES_LIST: (state, payload) => {
    state.DistributorsMasterMovieList = payload;
  },
  //setup mutations
  SET_ORG_IMAGE: (state, payload) => {
    state.OrgImage = payload;
  },
  SET_NO_SCREENS: (state, payload) => {
    state.noOfScreens = payload;
  },
  SET_CURRENT_CINEMA_INDEX: (state, payload) => {
    state.currentCinemaIndex = 1;
  },
  SET_BoxOfficeFnb_Back_SeatLayout: (state, payload) => {
    state.BacktoSeatLayout = true;
  },
  SET_WEEK_DAYS: (state, payload) => {
    state.DaysList = payload;
  },
  IS_CINEMA_MANAGER: state => {
    state.isCinemaManager = true;
  },
  IS_NOT_CINEMA_MANAGER: state => {
    state.isCinemaManager = false;
  },
  SET_DROPDOWN_SELECTED_CINEMA: (state, payload) => {
    state.dropdownSelectedCinema = payload;
  },
  SET_ALL_CINEMA_ARRAY: (state, payload) => {
    state.ALL_CINEMA_AARAY = payload;
  },
  SET_MOBILE_SIDEBAR: (state, payload) => {
    state.mobileSidebar = payload;
  },
  SET_IS_MOBILE: (state, payload) => {
    state.isMobile = payload;
  },
  SET_TEST_SETUP: (state, payload) => {
    let TestSetup = false;
    if (payload && payload == "Y") {
      TestSetup = true;
    } else {
      TestSetup = false;
    }
    state.TEST_SETUP = TestSetup;
  },
  SET_TIME_FORMAT: (state, payload) => {
    let format = "HH:mm";
    if (payload.toLowerCase() == "n") {
      format = "hh:mm:A";
    } else if (payload.toLowerCase() == "y") {
      format = "HH:mm";
    } else {
      format = "HH:mm";
    }
    state.TimeFormat = format;
    window.localStorage.setItem("TimeFormat", format);
  },
  SET_SEAT_POPUP_COUNT: (state, payload) => {
    if (!isNaN(payload) && payload > 0 && payload <= 10) {
      state.selectSeatCountPopUp = parseInt(payload);
    } else if (payload <= 0) {
      state.selectSeatCountPopUp = 1;
    } else {
      state.selectSeatCountPopUp = 10;
    }
  }
};

const actions = {
  onChangeAreaLanguage: ({ dispatch, commit, state }, payload) => {
    commit("SET_DROPDOWN_AREA_LANGUAGE", payload);
  },
  fetchGlobalOptions: ({ commit }, payload) => {
    if(state.global_options_latest && state.global_options_latest.length == 0) {
      MasterService.GetGlobalOptions().then(response => {
        const { data } = response;
        if (data && data.status && data.Records.length > 0) {
          const CLIENT_SETUP_NAME = data.Records.find(
            go => go.go_key == "CLIENT_SETUP_NAME"
          );
          commit("SET_CLIENT_SETUP_NAME", CLIENT_SETUP_NAME.go_value);

          const ALLOW_CINEMA_SPECIFIC_REFUND_ONLY = data.Records.find(
            go => go.go_key == "ALLOW_CINEMA_SPECIFIC_REFUND_ONLY"
          );
          commit("SET_ALLOW_CINEMA_SPECIFIC_REFUND_ONLY", ALLOW_CINEMA_SPECIFIC_REFUND_ONLY.go_value);

          const ALLOW_CINEMA_SPECIFIC_SWAP_ONLY = data.Records.find(
            go => go.go_key == "ALLOW_CINEMA_SPECIFIC_SWAP_ONLY"
          );
          commit("SET_ALLOW_CINEMA_SPECIFIC_SWAP_ONLY", ALLOW_CINEMA_SPECIFIC_SWAP_ONLY.go_value);

          const DEFAULT_SELECTED_FOOD_CATEGORY = data.Records.find(
            go => go.go_key == "DEFAULT_SELECTED_FOOD_CATEGORY_POS"
          );
          window.localStorage.setItem(
            "dflt_fc_id",
            JSON.stringify(DEFAULT_SELECTED_FOOD_CATEGORY.go_value)
          );
          commit(
            "SET_DEFAULT_SELECTED_FOOD_CATEGORY",
            DEFAULT_SELECTED_FOOD_CATEGORY.go_value
          );

          const IS_GOGO_CINEMA = data.Records.find(
            go => go.go_key == "IS_GOGO_CINEMA"
          );
          let isGogoCinema = IS_GOGO_CINEMA.go_value == "Y" ? true : false;
          commit("SET_GOGO_CINEMA", IS_GOGO_CINEMA.go_value);
          console.log("IS_GOGO_CINEMA.go_value", isGogoCinema);
          commit("SET_GLOBAL_OPTIONS", data.Records);

          const POS_INPUT_CASH_VALIDATION = data.Records.find(
            go => go.go_key == "POS_INPUT_CASH_VALIDATION"
          );

          if (POS_INPUT_CASH_VALIDATION && POS_INPUT_CASH_VALIDATION.go_value) {
            commit(
              "SET_POS_AMOUNT_VALIDATION",
              POS_INPUT_CASH_VALIDATION.go_value
            );
          }

          const POS_FINAL_PAGE_STANDBY_TIME_IN_MINS = data.Records.find(
            go => go.go_key == "POS_FINAL_PAGE_STANDBY_TIME_IN_MINS"
          );

          if (
            POS_FINAL_PAGE_STANDBY_TIME_IN_MINS &&
            POS_FINAL_PAGE_STANDBY_TIME_IN_MINS.go_value
          ) {
            commit(
              "SET_POS_FINAL_PAGE_STANDBY_TIME_IN_MINS",
              POS_FINAL_PAGE_STANDBY_TIME_IN_MINS.go_value
            );
          }

          const POS_LOCK_SCREEN_TIME = data.Records.find(
            go => go.go_key == "POS_LOCK_SCREEN_TIME"
          );

          if (POS_LOCK_SCREEN_TIME && POS_LOCK_SCREEN_TIME.go_value) {
            commit("POS_LOCK_SCREEN_TIME", POS_LOCK_SCREEN_TIME.go_value);
          }

          const POS_SEAT_EXTEND_ALERT_IN_SEC = data.Records.find(
            go => go.go_key == "POS_SEAT_EXTEND_ALERT_IN_SEC"
          );

          if (
            POS_SEAT_EXTEND_ALERT_IN_SEC &&
            POS_SEAT_EXTEND_ALERT_IN_SEC.go_value
          ) {
            commit(
              "POS_SEAT_EXTEND_ALERT_IN_SEC",
              POS_SEAT_EXTEND_ALERT_IN_SEC.go_value
            );
          }

          const SHOW_SMS_SECTION = data.Records.find(
            go => go.go_key == "SHOW_POS_SEND_SMS_SECTION"
          );

          commit("SET_SHOW_SMS_SECTION", SHOW_SMS_SECTION.go_value);

          const OPEN_APPLICABLE_OFFER_POPUP = data.Records.find(
            go => go.go_key == "OPEN_APPLICABLE_OFFER_POPUP"
          );

          commit("SET_OFFER_POPUP_OPEN_AUTOMATICALLY", OPEN_APPLICABLE_OFFER_POPUP.go_value);

          const CONTENT_LANG_ARRAY = data.Records.find(
            go => go.go_key == "KIOSK_LANGUAGE"
          );

          commit(
            "SET_CONTENT_LANGUAGES",
            JSON.parse(CONTENT_LANG_ARRAY.go_value)
          );

          const SELECT_SEAT_POPUP_COUNT = data.Records.find(
            go => go.go_key == "SELECT_SEAT_COUNT_POPUP"
          );

          const TIME_FORMAT = data.Records.find(
            go => go.go_key == "24_HRS_FORMAT"
          );
          commit("SET_TIME_FORMAT", TIME_FORMAT.go_value);

          const POS_DIRECT_PRINT = data.Records.find(
            go => go.go_key == "POS_DIRECT_PRINT"
          );
          commit("SET_DIRECT_PRINT", POS_DIRECT_PRINT.go_value);

          const MANAGER_AUTH_REQ_FOR_CHANGES = data.Records.find(
            go => go.go_key == "MANAGER_AUTH_REQURIED_FOR_CHANGES"
          );
          commit("SET_AUTH_REQURIED_FOR_CHANGES", MANAGER_AUTH_REQ_FOR_CHANGES.go_value);

          const SHOW_VEG_NONVEG_lOGO = data.Records.find(
            go => go.go_key == "SHOW_VEG_NONVEG_lOGO"
          );
          commit("SET_SHOW_VEG_NONVEG_lOGO", SHOW_VEG_NONVEG_lOGO.go_value);
          
          const AUTO_ADMIT_TICKET_AFTER_SHOW = data.Records.find(
            go => go.go_key == "AUTO_SCAN_TICKETS_AFTER_SHOW_STARTS"
          );
          commit("SET_AUTO_ADMIT_TICKET", AUTO_ADMIT_TICKET_AFTER_SHOW.go_value);

          const MANAGER_AUTH_REQ_FOR_REPRINT = data.Records.find(
            go => go.go_key == "MANAGER_AUTH_REQURIED_FOR_REPRINT"
          );
          commit("SET_AUTH_REQURIED_FOR_REPRINT", MANAGER_AUTH_REQ_FOR_REPRINT.go_value);

          const SHOW_PRINT_RECEIPT_BTN_POS = data.Records.find(
            go => go.go_key == "SHOW_PRINT_RECEIPT_BTN_POS"
          );
          commit(
            "SET_PRINT_RECEIPT_BTN_POS",
            SHOW_PRINT_RECEIPT_BTN_POS.go_value
          );

          const DELIVER_ITEM_FROM_POS_PICKUP = data.Records.find(
            go => go.go_key == "DELIVER_ITEM_FROM_POS_PICKUP"
          );
          commit(
            "SET_DELIVER_ITEM_FROM_POS_PICKUP",
            DELIVER_ITEM_FROM_POS_PICKUP.go_value
          );
          
          const USE_TIM_INTEGRATION = data.Records.find(
            go => go.go_key == "USE_TIM_INTEGRATION"
          );
          commit(
            "SET_TIM_INTEGRATION",
            USE_TIM_INTEGRATION.go_value
          );

          const DIRECT_DELIVER_READY_TO_SERVE_ITEMS = data.Records.find(
            go => go.go_key == "DIRECT_DELIVER_READY_TO_SERVE_ITEMS"
          );
          commit(
            "SET_DIRECT_DELIVER_READY_TO_SERVE_ITEMS",
            DIRECT_DELIVER_READY_TO_SERVE_ITEMS.go_value
          );

          const PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY = data.Records.find(
            go => go.go_key == "PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY"
          );
          commit(
            "SET_PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY",
            PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY.go_value
          );

          const NEOLEAP_WEBSOCKET_URL = data.Records.find(
            go => go.go_key == "NEOLEAP_WEBSOCKET_URL"
          );
          commit(
            "SET_NEOLEAP_WEBSOCKET_URL",
            NEOLEAP_WEBSOCKET_URL.go_value
          );

          const USE_NEOLEAP_POS_PAYMENT = data.Records.find(
            go => go.go_key == "USE_NEOLEAP_POS_PAYMENT"
          );
          commit(
            "SET_NEOLEAP_INTEGRATION",
            USE_NEOLEAP_POS_PAYMENT.go_value
          );

          const HARDWARE_SETTING_ON_POS = data.Records.find(
            go => go.go_key == "HARDWARE_SETTING_ON_POS"
          );
          commit(
            "SET_HARDWARE_SETTING_ON_POS",
            HARDWARE_SETTING_ON_POS.go_value
          );

          const TEST_SETUP = data.Records.find(go => go.go_key == "TEST_SETUP");
          commit("SET_TEST_SETUP", TEST_SETUP.go_value);

          const PRINT_CARD_HOLDER_RECEIPT_FROM_POS = data.Records.find(go => go.go_key == "PRINT_CARD_HOLDER_RECEIPT_FROM_POS");
          commit("SET_PRINT_TIM_RECEIPT_FROM_POS", PRINT_CARD_HOLDER_RECEIPT_FROM_POS.go_value);

          commit("SET_SEAT_POPUP_COUNT", SELECT_SEAT_POPUP_COUNT.go_value);
        } else {
          console.log("Erro in fetching global options");
        }
      });
    }
    // commit("SET_GLOBAL_OPTIONS", payload);
  },
  fetchHealthMeta: ({ commit }) => {
    let payload = {
      git: {},
      os: {},
      process: {}
    };

    MasterService.GetHealthMeta()
      .then(response => {
        const { data } = response;
        payload = data;
      })
      .catch(console.log)
      .finally(() => {
        commit("SET_HEALTH_META", payload);
      });
  },
  fetchOrgDetails: ({ commit }, payload) => {
    MasterService.GetOrgDetails().then(response => {
      const { data } = response;
      if (data && data.status && data.Records.length > 0) {
        commit("SET_ORG_DETAILS", data.Records[0]);
      } else {
        console.log("Error", data.message);
      }
    });
  },
  HARD_RELOAD_POS: ({ commit }, payload) => {
    window.location.reload();
  },
  setDropdownCinema: ({ commit }, payload) => {
    MasterService.GetCinemas()
      .then(response => {
        const { data } = response;
        if (data.status) {
          if (data.Records && data.Records.length == 1) {
            window.localStorage.setItem(
              "dropDownCinema",
              JSON.stringify(data.Records[0])
            );
            commit("SET_DROPDOWN_SELECTED_CINEMA", data.Records[0]);
          } else {
            if (window.localStorage.getItem("dropDownCinema")) {
              let cinemaObj = JSON.parse(
                window.localStorage.getItem("dropDownCinema")
              );
              commit("SET_DROPDOWN_SELECTED_CINEMA", cinemaObj);
            }
          }
        } else {
          console.log("Error", data.message);
        }
      })
      .catch(err => {
        console.log("Error", err);
      });
  },
  boxOfficefnb_back_seatlayout: ({ commit }, payload) => {
    commit("SET_BoxOfficeFnb_Back_SeatLayout", payload);
  },
  selectDropdownCinema: ({ commit }, payload) => {
    window.localStorage.setItem("dropDownCinema", JSON.stringify(payload));
    commit("SET_DROPDOWN_SELECTED_CINEMA", payload);
  },
  fetchCinemasList: ({ dispatch, commit, state }, payload) => {
    // let body = {
    //   tableName: "ms_cinemas",
    //   cine_is_active: "Y",
    // };
    // if (payload && payload['cinemaId'] && String(payload.cinemaId).length > 0) {
    //   body['cine_id'] = payload.cinemaId
    // }
    MasterService.GetCinemas({ cine_id: payload.cinemaId })
      .then(async response => {
        const { data } = response;
        if (data && data.status) {
          data.Records.length > 0
            ? commit("SET_CINEMAS_LIST", data.Records || [])
            : "";
          if (
            payload &&
            payload["cinemaId"] &&
            String(payload.cinemaId).length > 0
          ) {
            await commit("IS_CINEMA_MANAGER");
            // await dispatch('onTransactionRefundsDropDownHandler',{name: 'isCinema',selectedItem:{cine_id: data.Records[0].cine_id,cine_name:data.Records[0].cine_name}})
            // await dispatch('onSummaryReportDropdownHandler',{name: 'isCinema',selectedItem:{cine_id: data.Records[0].cine_id,cine_name:data.Records[0].cine_name}})
            // await dispatch('onPerformanceReportFlagHandler',{
            //   event: null,
            //   name: "isCinema",
            //   value: data.Records[0].cine_id
            // });
          } else {
            await commit("IS_NOT_CINEMA_MANAGER");
            // await commit('UNSELECT_CINEMA')
            // await commit('UNSELECT_SUMMARY_CINEMA')
            // await commit('UNSELECT_PERFORMANCE_CINEMA')
          }
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        console.log("error >>>>>>>>>:>> ", error);
        Vue.toasted.show("Catch Error on MasterStore fetchCinemasList", error);
      });
  },
   fetchAllCinemasList: ({ dispatch, commit, state }, payload) => {
    MasterService.GetAllCinema({})
      .then(async response => {
        const { data } = response;
        if (data && data.status) {
          commit("SET_ALL_CINEMA_ARRAY", data.Records);
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        console.log("error >>>>>>>>>:>> ", error);
        Vue.toasted.show("Catch Error on MasterStore fetchCinemasList", error);
      });
  },
  fetchRawMaterialCategory: ({ dispatch, commit, state }, payload) => {
    let body = {
      tableName: "ms_raw_material_category",
      rmc_is_active: "Y"
    };
    MasterService.GetActiveList(body)
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          data.Records.length > 0
            ? commit("SET_RAW_MATERIAL_CATEGORY_LIST", data.Records || [])
            : "";
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on MasterStore fetchCinemasList", error);
      });
  },
  fetchDistributorsList: ({ dispatch, commit, state }, payload) => {
    let body = {
      tableName: "ms_distributors",
      d_is_active: "Y"
    };
    // screen_id: screen.screen_id
    MasterService.GetActiveList(body)
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          data.Records.length > 0
            ? commit("SET_DISTRIBUTORS_LIST", data.Records || [])
            : "";
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error =>
        Vue.toasted.show(
          "Catch Error on MasterStore fetchDistributorsList",
          error
        )
      );
  },
  fetchDistributorsActiveMasterMovie: (
    { dispatch, commit, state },
    payload
  ) => {
    DistributorService.GetDistributorActiveMasterMovie()
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records.length > 0)
            commit("SET_DISTRIBUTORS_MASTER_MOVIES_LIST", data.Records || []);
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error =>
        Vue.toasted.show(
          "Catch Error on MasterStore fetchDistributorsActiveMasterMovie",
          error
        )
      );
  },
  fetchPosUsersList: ({ dispatch, commit, state }, payload) => {
    let body = {
      role_id: "4, 8",
      cinema_id: payload.cinema_id
    };
    MasterService.GetActiveUsersAccordingRolesList(body)
      .then(response => {
        const { data } = response;
        if (data && data.status && data.Records) {
          data.Records.length > 0
            ? commit("SET_POS_USERS_LIST", data.Records || [])
            : "";
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        console.log("error :>> ", error);
        Vue.toasted.show("Catch Error on MasterStore fetchPosUsersList", error);
      });
  },
  fetchHardwareLocations: ({ dispatch, commit, state }, payload) => {
    let HardwareLocations = []
    if(payload.cinema_id) {
      let body = {
        cinema_id: payload.cinema_id
      };
      MasterService.getHardwarelocationByCinema(body)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            HardwareLocations = data.Records;
            console.log('fetchHardwareLocations',HardwareLocations);
            commit("SET_HARDWARE_LOCATION_LIST", data.Records)
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch Error on getHardwareLocations :", error);
        });
    } else {
      console.log('no cinema id in hardware location');
      commit("SET_HARDWARE_LOCATION_LIST", [])
    }
  },
  fetchPosHardwareSettings: ({ dispatch, commit, state }, payload) => {
    let body = {
      unique_id: payload,
    };
    MasterService.getPosHardwareSettings(body)
      .then(response => {
        const { data } = response;
        if (data && data.status && data.Records.length > 0) {
          commit("SET_HARDWARE_SETTINGS_OBJ", data.Records[0])
          dispatch("fetchHardwareLocations", {cinema_id: data.Records[0].cinema_id})
        } else {
          console.log("data.message :", data.message);
        }
      })
      .catch(error => {
        console.log("Catch Error on getHardwareLocations :", error);
      });
  },
  fetchAggregatorsUsersList: ({ dispatch, commit, state }, payload) => {
    let body = {
      tableName: "users",
      role_id: "10"
    };
    MasterService.GetActiveList(body)
      .then(response => {
        const { data } = response;
        if (data && data.status && data.Records) {
          data.Records.length > 0
            ? commit("SET_AGGREGATOR_USERS_LIST", data.Records || [])
            : "";
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on MasterStore fetchPosUsersList", error);
      });
  },
  fetchPaymentTypesList: ({ dispatch, commit, state }, payload) => {
    let body = {
      tableName: "ms_payment_modes",
      pm_is_active: "Y"
    };
    MasterService.GetActiveList(body)
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          data.Records.length > 0
            ? commit("SET_PAYMENT_TYPES_LIST", data.Records || [])
            : "";
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        Vue.toasted.show(
          "Catch Error on MasterStore fetchPaymentTypesList",
          error
        );
      });
  },
  //setup actions
  setOrgImage: ({ dispatch, commit, state }, payload) => {
    commit("SET_ORG_IMAGE", payload);
  },
  setNoOfScreens: ({ dispatch, commit, state }, payload) => {
    commit("SET_NO_SCREENS", payload);
  },
  setCurrentCinemaIndex: ({ dispatch, commit, state }, payload) => {
    commit("SET_CURRENT_CINEMA_INDEX", payload);
  },
  globalRemoveFile: ({ dispatch, commit, state }, payload) => {
    // /api/admin / removereportfile
    MasterService.GlobalRemoveFile(payload)
      .then(response => {
        const { data } = response;

        // console.log('data :', data);
      })
      .catch(error => {
        console.log("error :", error);
      });
  },
  fetchOfferVoucherTypesList: ({ dispatch, commit, state }, payload) => {
    // THIS IS FOR fUTURE
    // let body = {
    //     tableName: "",
    // };
    // MasterService.GetActiveList(body)
    //     .then(response => {
    //         const { data } = response;
    //         if (data && data.status && data.Records.length > 0) commit('SET_OFFERS_VOUCHER_TYPES_LIST', data.Records || []);
    //         else Vue.toasted.show(data.message || 'Opps! Something went wrong');
    //     })
    //     .catch(error => {
    //         Vue.toasted.show("Catch Error on MasterStore fetchOfferVoucherTypesList", error);
    //     });
  },
  fetchDaysList: ({ dispatch, commit, state }, payload) => {
    MasterService.getDays()
      .then(response => {
        const { data } = response;
        commit("SET_WEEK_DAYS", data.data || []);
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on MasterStore fetchWeekDays", error);
      });
  },
  set_dropdown_area_language: ({ dispatch, commit, state }, payload) => {
    let selected_lang = {
      lang_name: "German",
      lang_id: 52,
      iso_2: "de",
      iso_3: "deu"
    };
    if (window.localStorage.getItem("area_lang")) {
      selected_lang = JSON.parse(window.localStorage.getItem("area_lang"));
      commit("SET_DROPDOWN_AREA_LANGUAGE", selected_lang);
    } else {
      if (state.contentLangArray && state.contentLangArray.length > 0) {
        selected_lang =
          state.contentLangArray.find(x => x.iso_2.toLowerCase() == "de") || "";
        commit("SET_DROPDOWN_AREA_LANGUAGE", selected_lang);
      }
    }
  },
  hotPickModule: ({ dispatch, commit, state }, payload) => {
    let body = {
      module_id: payload
    };
    console.log("hotPickModule payload", payload);
    MasterService.hotPickModule(body)
      .then(response => {
        const { data } = response;
        if (data.status) {
          dispatch("fetchUserHotPickModules");
        }
        console.log("hotPickModule data", data);
      })
      .catch(error => Vue.toasted.show("Catch Error on MasterStore", error));
  },
  fetchUserHotPickModules: ({ dispatch, commit, state }, payload) => {
    commit("SET_HOT_PICKS_MODULES", []);
    MasterService.getHotPickModules()
      .then(response => {
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          commit("SET_HOT_PICKS_MODULES", data.Records);
        }
        console.log("getHotPickModules data", data);
      })
      .catch(error => Vue.toasted.show("Catch Error on MasterStore", error));
  },
  setMobileSidebar({ commit }, payload) {
    commit("SET_MOBILE_SIDEBAR", payload);
  },
  setIsMobile({ commit }, payload) {
    commit("SET_IS_MOBILE", payload);
    // console.log("set isMobile", payload);
  }
};

const getters = {
  getGlobalOptions: state => state.global_options_latest,
  getHealthMeta: state => state.health_meta,
  getbacktoseatlayout: state => state.BacktoSeatLayout,
  // THIS IS FOR FUTURE
  getOfferVoucherTypesList: state => state.OfferVoucherTypesList,

  getCinemasList: state => state.CinemasList,
  getDistributorsList: state => state.DistributorsList,
  getPosUsersList: state => state.PosUsersList,
  getAggregatorUserList: state => state.AggregatorUserList,
  getPaymentTypesList: state => state.PaymentTypesList,
  getDistributorsMasterMovieList: state => state.DistributorsMasterMovieList,
  getWeekDaysList: state => state.DaysList,
  getRawMaterialCategoryList: state => state.RawMaterialCategoryList,
  //setup store
  getOrgImage: state => state.OrgImage,
  noOfScreens: state => state.noOfScreens,
  currentCinemaIndex: state => state.currentCinemaIndex,
  isCinemaManager: state => state.isCinemaManager,
  getSelectedDropDownCinema: state => state.dropdownSelectedCinema,
  getOrganizationDetails: state => state.organizationDetails,
  getHotPickModules: state => state.hotPickModules,
  isGogoCinema: state => state.isGogoCinema,
  getMobileSidebar: state => state.mobileSidebar,
  getIsMobile: state => state.isMobile,
  isReprint: state => state.isReprint,
  seatCountPopUp: state => state.selectSeatCountPopUp,
  isTestSetup: state => state.TEST_SETUP,
  TimeFormat: state => state.TimeFormat,
  ShowSendSMSSection: state => state.show_send_sms_section,
  DirectPrint: state => state.direct_print,
  POS_AMOUNT_CALCULATION_CHECK: state => state.pos_amount_calculation_check,
  POS_FINAL_PAGE_STANDBY_TIME: state => state.pos_final_page_standby_time,
  CONTENT_LANG_ARRAY: state => state.contentLangArray,
  SELECTED_AREA_LANGUAGE: state => state.selected_content_language,
  AREA_LANG_ID: state => state.area_lang_id,
  POS_SEAT_EXTEND_TIMER: state => state.seat_extend_timer,
  POS_SEAT_ALERT_TIME_IN_SEC: state => state.pos_seat_release_alert_time_in_sec,
  CINE_SEAT_RELEASE_TIME_IN_MINS: state => state.cine_seat_release_time,
  CLIENT_SETUP_NAME: state => state.client_setup_name,
  POS_LOCK_SCREEN_TIME: state => state.pos_lock_screen_time,
  DEFAULT_SELECTED_FOOD_CATEGORY: state => state.default_selected_food_category,
  showPrintReceiptBtn: state => state.showPrintReceiptBtn,
  MANAGER_AUTH_FOR_CHANGES: state => state.MANAGER_AUTH_FOR_CHANGES,
  MANAGER_AUTH_FOR_REPRINT: state => state.MANAGER_AUTH_FOR_REPRINT,
  SHOW_VEG_NONVEG_lOGO: state => state.SHOW_VEG_NONVEG_lOGO,
  AUTO_ADMIT_TICKET_AFTER_SHOW: state => state.AUTO_ADMIT_TICKET_AFTER_SHOW,
  OPEN_OFFER_POPUP_AUTOMATICALLY: state => state.OPEN_OFFER_POPUP,
  USE_TIM_INTEGRATION: state => state.USE_TIM_INTEGRATION,
  USE_NEOLEAP_POS_PAYMENT: state => state.USE_NEOLEAP_POS_PAYMENT,
  PRINT_TIM_CARD_RECEIPT_POS: state => state.PRINT_TIM_CARD_RECEIPT_POS,
  HARDWARE_LOCATIONS: state => state.HARDWARE_LOCATIONS,
  HARDWARE_LOCATION_ID: state => state.hardwareLocationId,
  DELIVER_ITEM_FROM_POS_PICKUP: state => state.DELIVER_ITEM_FROM_POS_PICKUP,
  POS_HARDWARE_SETTINGS: state => state.HardwareSettings,
  HARDWARE_SETTING_ON_POS: state => state.HARDWARE_SETTING_ON_POS,
  ALL_CINEMA_AARAY: state => state.ALL_CINEMA_AARAY,
  NEOLEAP_WEBSOCKET_URL: state => state.NEOLEAP_WEBSOCKET_URL,
  DIRECT_DELIVER_READY_TO_SERVE_ITEMS: state => state.DIRECT_DELIVER_READY_TO_SERVE_ITEMS,
  PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY: state => state.PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY,
  ALLOW_CINEMA_SPECIFIC_REFUND_ONLY: state => state.ALLOW_CINEMA_SPECIFIC_REFUND_ONLY,
  ALLOW_CINEMA_SPECIFIC_SWAP_ONLY: state => state.ALLOW_CINEMA_SPECIFIC_SWAP_ONLY,
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/MasterStore.js